const modals = {};

export default modals;
